//	Supported notification methods
const notificationMethods = {
	INAPP: {
		type: 'INAPP'
	},
	EMAIL: {
		type: 'EMAIL'
	}
}

notificationMethods.all = [notificationMethods.INAPP.type, notificationMethods.EMAIL.type]

export default notificationMethods



// WEBPACK FOOTER //
// ./src/enums/notificationMethods.js